/* ============================================================
   NORTHSHEEP — product page: cap the right info column to the LEFT
   media box height (desktop >= 990px).

   Sets --ns-pdp-media-h on :root from the actual media box height.
   northsheep-product.css uses it as the info column's max-height
   (min(--ns-pdp-media-h, viewport)). If this JS does not load, the
   CSS falls back to the viewport cap and still scrolls.

   Uses Dawn's NATIVE .product__media-wrapper so it works even if the
   custom section markup isn't live. Recalculates on load, resize,
   and whenever the media box resizes (image load / variant switch).
   ============================================================ */
/* EVERY COLOUR SWAP RUNS THIS FILE AGAIN: it sits inside <main> (CLAUDE.md, "A
   COLOUR SWAP RE-RUNS EVERY SCRIPT INSIDE <main>"). Each run counts itself
   here, and the window and document listeners of an earlier run step aside
   (`mine()` below), so ten swaps no longer mean ten copies of the same work on
   every resize and scroll (audit, 4 Oct 2026, S9). The newest run does exactly
   what a fresh page does. */
window.__nsPdpRun = (window.__nsPdpRun || 0) + 1;

(function () {
  var run = window.__nsPdpRun;
  function mine() {
    return run === window.__nsPdpRun;
  }
  var root = document.documentElement;

  function mediaBox() {
    return (
      document.querySelector('.product__media-wrapper .product__media-list') ||
      document.querySelector('.product__media-wrapper media-gallery') ||
      document.querySelector('.product__media-wrapper')
    );
  }

  function sync() {
    if (window.innerWidth < 990) {
      root.style.removeProperty('--ns-pdp-media-h');
      return;
    }
    var m = mediaBox();
    if (!m) return;
    var h = m.getBoundingClientRect().height;
    if (h > 200) {
      root.style.setProperty('--ns-pdp-media-h', Math.round(h) + 'px');
    }
  }

  function init() {
    if (!document.querySelector('.product__media-wrapper')) return; // product pages only
    sync();
    var onWindow = function () {
      if (mine()) sync();
    };
    window.addEventListener('resize', onWindow, { passive: true });
    window.addEventListener('load', onWindow);

    var m = mediaBox();
    if (window.ResizeObserver && m) {
      new ResizeObserver(sync).observe(m);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   NORTHSHEEP — thumbnail strip "more images" hint.
   Toggles .ns-thumbs-overflow on each .thumbnail-slider when its
   horizontal thumbnail list overflows, and .ns-thumbs-end once it
   is scrolled to the end, so the right-edge fade + chevron only
   shows while there are more thumbnails off-screen.
   ============================================================ */
(function () {
  var run = window.__nsPdpRun;
  function mine() {
    return run === window.__nsPdpRun;
  }
  function setup(slider) {
    var list = slider.querySelector('.thumbnail-list');
    if (!list) return;

    function update() {
      var overflow = list.scrollWidth - list.clientWidth;
      if (overflow > 4) {
        // Right hint while there is more to the right; left hint once scrolled.
        slider.classList.toggle('ns-thumbs-can-right', list.scrollLeft < overflow - 4);
        slider.classList.toggle('ns-thumbs-can-left', list.scrollLeft > 4);
      } else {
        slider.classList.remove('ns-thumbs-can-right');
        slider.classList.remove('ns-thumbs-can-left');
      }
    }

    // Hover + mouse wheel scrolls the strip HORIZONTALLY (no need to click).
    slider.addEventListener(
      'wheel',
      function (e) {
        var overflow = list.scrollWidth - list.clientWidth;
        if (overflow <= 0) return;
        var delta = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
        if (!delta) return;
        // Only hijack the wheel while the strip can still scroll in that direction,
        // so the page keeps scrolling once you hit either end.
        var atStart = list.scrollLeft <= 0;
        var atEnd = list.scrollLeft >= overflow - 1;
        if ((delta < 0 && atStart) || (delta > 0 && atEnd)) return;
        e.preventDefault();
        list.scrollLeft += delta;
        update();
      },
      { passive: false }
    );

    list.addEventListener('scroll', update, { passive: true });
    var onWindow = function () {
      if (mine()) update();
    };
    window.addEventListener('resize', onWindow, { passive: true });
    window.addEventListener('load', onWindow);
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(list);
    }
    update();
  }

  function init() {
    var sliders = document.querySelectorAll('.product__media-wrapper .thumbnail-slider');
    sliders.forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ------------------------------------------------------------------
   A DOT BETWEEN PROMISES THAT SHARE A LINE, NONE AT THE START OF ONE
   (owner, 2 Oct 2026: "can you also add a dot between 75 € and 30 so they
   see better its 2 seperate text. or wherever the text splits based on
   devices but dont use a dot in front of a new line").

   The promises under the delivery date are separated by a small dot, drawn as
   a ::before on every item after the first (`.item + .item`). When the row
   wraps (phone widths, the longer languages, always at 13px) the item that
   moves to the next line would take its dot along and open the line with a
   dot in front of nothing. Until 2 Oct that was solved by taking ALL the dots
   away as soon as the row wrapped, which left two promises on one line with
   nothing between them: "ab 75 €  30 Tage Rückgabe" read as one sentence.

   Now every line keeps its own dots and only a line's first promise has none.
   CSS cannot do it (no selector knows where a line begins), so this:
     1. takes out what it put in last time and measures the row WITH EVERY
        DOT IN: the natural layout, one answer;
     2. puts a line break (.ns-pdp-trust__break, a full-width flex item) in
        front of every promise that began a new line.
   The break does two jobs. The dot is drawn for `.item + .item`, so a promise
   right after a break has none. And it PINS the line: an earlier version hid
   the dot of the promise that began a line, which freed 17px, the promise came
   back up onto the first line and sat there without its dot. With the break in
   front of it, it cannot move, whatever the freed pixels.

   Cheap by construction: offsetTop reads on load, a debounced width change,
   the webfont's arrival and a colour swap (which brings a new row). It writes
   only inside the row and never touches scroll position (see CLAUDE.md).
   ------------------------------------------------------------------ */
(function () {
  var run = window.__nsPdpRun;
  function mine() {
    return run === window.__nsPdpRun;
  }
  function mark() {
    var rows = document.querySelectorAll('.ns-pdp-trust');
    for (var r = 0; r < rows.length; r++) {
      var row = rows[r];
      var old = row.querySelectorAll('.ns-pdp-trust__break');
      for (var o = 0; o < old.length; o++) old[o].parentNode.removeChild(old[o]);
      row.classList.remove('ns-pdp-trust--lines');
      var items = row.querySelectorAll('.ns-pdp-trust__item');
      var starts = [];
      for (var i = 1; i < items.length; i++) {
        /* Within a pixel: a baseline-aligned row can differ by a fraction
           between items of different heights without being a new line. */
        if (Math.abs(items[i].offsetTop - items[i - 1].offsetTop) > 1) starts.push(items[i]);
      }
      if (!starts.length) continue;
      row.classList.add('ns-pdp-trust--lines');
      for (var s = 0; s < starts.length; s++) {
        var br = document.createElement('span');
        br.className = 'ns-pdp-trust__break';
        br.setAttribute('aria-hidden', 'true');
        row.insertBefore(br, starts[s]);
      }
    }
  }

  var pending;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(mark, 60);
  }

  /* A width change is the only thing that can move where the lines break.
     Watching the PARENT and comparing widths, not the row itself: the breaks
     change the row's own height, so observing the row would re-trigger this
     from its own output. The parent's width never moves for that reason. */
  function watch() {
    if (!window.ResizeObserver) return;
    var rows = document.querySelectorAll('.ns-pdp-trust');
    for (var r = 0; r < rows.length; r++) {
      var parent = rows[r].parentElement;
      if (!parent || parent.__nsTrustWatch) continue;
      parent.__nsTrustWatch = true;
      (function (parent) {
        var lastWidth = parent.getBoundingClientRect().width;
        new ResizeObserver(function (entries) {
          var width = entries[0].contentRect.width;
          if (Math.abs(width - lastWidth) < 0.5) return;
          lastWidth = width;
          schedule();
        }).observe(parent);
      })(parent);
    }
  }

  function init() {
    if (!document.querySelector('.ns-pdp-trust')) return;
    mark();
    watch();
    window.addEventListener('resize', function () {
      if (mine()) schedule();
    }, { passive: true });
    /* The row is laid out in the fallback face first; every width in it
       changes when Inter arrives, which can make or break a line. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () {
      if (mine()) mark();
    });
    /* And on load: the first pass runs at DOMContentLoaded, when a stylesheet
       that sizes this row can still be in flight. */
    window.addEventListener('load', function () {
      if (mine()) mark();
    });
    /* A colour swap replaces the product section, row included. */
    document.addEventListener('ns:colour-swapped', function () {
      if (!mine()) return;
      watch();
      mark();
      schedule();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ------------------------------------------------------------------
   THE CAMERA BADGE OPENS ON A TAP (phones and tablets).

   On a mouse the words are revealed by :hover and this does nothing. A touch
   screen has no hover, so the badge is a button and a tap adds .is-open.

   It closes again on the next scroll, on a tap anywhere else, and on its own
   after a few seconds — because it sits over the filmstrip, and an open pill
   is a wide patch of the picture that will not flick a photograph. Closed is
   the state it should spend its time in.

   SCROLL, NOT TOUCHSTART. A page arriving from a back gesture can have a
   finger on the glass before the first frame, so a touchstart listener that
   means "the shopper moved on" fires immediately and closes what was never
   open. See CLAUDE.md. `scroll` and `pointerdown` outside the badge say the
   same thing without that failure.
   ------------------------------------------------------------------ */
(function () {
  var run = window.__nsPdpRun;
  function mine() {
    return run === window.__nsPdpRun;
  }
  var OPEN_MS = 4000;

  /* SAME SIZE, SAME INSET, OPPOSITE SIDE (owner, 22 Sep 2026: "same size and
     px from left and top as the closing button but then on the left so they
     look symmeterical").

     Matching the numbers in CSS was not enough, and measuring said why: the
     two controls hang off DIFFERENT boxes. The × is placed by placeClose() in
     ns-magnifier.js against the photo FRAME, which on a phone is full-bleed
     and can be wider than the screen — so it clamps to 10px from the window
     edge. The badge is positioned against the media COLUMN, which is inset by
     the page gutter. Measured at 375px: the × landed 10px from the window, the
     badge 26px. That is the gap the owner can see.

     So this mirrors placeClose's arithmetic on the other side: the frame's own
     left edge, clamped at the window, plus the same 10. Vertically it takes
     the frame's top without placeClose's max(top, 0) — that clamp exists to
     keep the × reachable while the zoom holds the page still, and the badge
     has no such moment.

     Kept to coarse pointers, where the two are ever seen together. On a mouse
     the CSS is left alone. */
  var GAP = 10;

  /* LINED UP WITH THE PAGE (owner, 23 Sep 2026: the camera and the × should
     match "the previous and next button above so it looks more uniform").

     Measured first: all four circles were already the same 40px. What
     differed was the inset. On a phone the photograph runs edge to edge while
     the arrows sit on the page gutter, so at 390px the arrows started 16px in
     and the camera 10px — each photo control 6px outside the arrow above it.
     The owner chose to line them up.

     So on a phone the inset IS the page gutter: from the full-bleed frame's
     visible edge to the media column's edge, which is where the arrows, the
     breadcrumb and the title all start. Read, not written down, so a store
     with a different page margin lines up as well. Where the frame is not
     full-bleed (a tablet, a desktop) there is no gutter between the two and
     the old 10px stands. The × takes the same measure — placeClose() in
     ns-magnifier.js asks window.nsPhotoInset — so the pair stays a pair. */
  function gutter(frame, side) {
    var column = frame && frame.closest('.product__media-wrapper');
    if (!column) return GAP;
    var c = column.getBoundingClientRect();
    var r = frame.getBoundingClientRect();
    var g = side === 'right'
      ? Math.min(r.right, window.innerWidth) - c.right
      : c.left - Math.max(r.left, 0);
    return g >= 4 ? g : GAP;
  }
  window.nsPhotoInset = gutter;

  function place(badge) {
    var column = badge.offsetParent;
    if (!column) return;
    if (!window.matchMedia('(hover: none)').matches) {
      badge.style.left = '';
      badge.style.top = '';
      return;
    }
    /* The frame the × is placed against: the first photo's container. */
    var frame = column.querySelector('.product__media-item .product-media-container');
    if (!frame) return;
    var c = column.getBoundingClientRect();
    var r = frame.getBoundingClientRect();
    var inset = gutter(frame, 'left');
    /* Same method as placeClose(): the column's inner edge (border included)
       is subtracted and nothing is rounded, so the badge and the × both sit
       exactly one inset below the same photo edge — rounding at two different
       moments put them half a pixel apart. */
    var ccs = getComputedStyle(column);
    var ox = c.left + (parseFloat(ccs.borderLeftWidth) || 0);
    var oy = c.top + (parseFloat(ccs.borderTopWidth) || 0);
    badge.style.left = (Math.max(r.left, 0) + inset - ox) + 'px';
    badge.style.top = (r.top + inset - oy) + 'px';
  }

  function init() {
    var badges = document.querySelectorAll('[data-ns-photo-badge]');
    if (!badges.length) return;

    badges.forEach(function (badge) {
      place(badge);
      /* The frame is sized from the first photo, which arrives after this
         runs; and the page gutter changes with the window. Neither fires on a
         scroll, so nothing here can touch a fling. */
      window.addEventListener('load', function () {
        if (mine()) place(badge);
      });
      window.addEventListener(
        'resize',
        function () {
          if (mine()) place(badge);
        },
        { passive: true }
      );
      if (window.ResizeObserver) {
        var frame = badge.offsetParent && badge.offsetParent.querySelector('.product__media-item .product-media-container');
        if (frame) {
          new ResizeObserver(function () {
            place(badge);
          }).observe(frame);
        }
      }
      var timer;

      function close() {
        if (!badge.classList.contains('is-open')) return;
        badge.classList.remove('is-open');
        badge.setAttribute('aria-expanded', 'false');
        clearTimeout(timer);
      }

      badge.addEventListener('click', function (event) {
        /* Never let the tap reach the picture underneath — on a gallery that
           opens a lightbox on click, this would open one every time. */
        event.preventDefault();
        event.stopPropagation();
        if (badge.classList.contains('is-open')) {
          close();
          return;
        }
        badge.classList.add('is-open');
        badge.setAttribute('aria-expanded', 'true');
        clearTimeout(timer);
        timer = setTimeout(close, OPEN_MS);
      });

      document.addEventListener('pointerdown', function (event) {
        if (mine() && !badge.contains(event.target)) close();
      });

      window.addEventListener('scroll', function () {
        if (mine()) close();
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
